import { useCallback, useEffect, useMemo, useState } from 'react';
import { T, Translations } from 'ia-react-core/~/interfaces/t';
import Translation from '../../services/translation/Translation';

const useTranslation = <Trans extends Translations = { [index: string]: string }>(namespace?: string) => {
  const [language, setLanguage] = useState(Translation.language);

  const t = useCallback<T<Trans>>((key, options: Record<string, unknown>) => {
    const keyWithNamespace = namespace && !(key as string).includes(':') ?
      `${namespace}:${key as string}` :
      key;

    return Translation.t(keyWithNamespace as string, options);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [namespace, language]);

  const result = useMemo(() => ({
    language,
    t,
    changeLanguage: (newLanguage: string) => Translation.changeLanguage(newLanguage),
  }), [language, t]);

  useEffect(() => Translation.onLanguageChange(setLanguage), []);

  return result;
};

/**
 * @visibleName useTranslation
 * @component
 */
export default useTranslation;
